var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M39.514 10.03c1.138 0 2.15.52 2.786 1.326L23.822 26.142 5.509 11.624c.612-.956 1.717-1.595 2.977-1.595zM5 34.643V14.248l13.14 10.417L5.027 35.061A3 3 0 0 1 5 34.644m1.202 2.513c.612.507 1.41.814 2.284.814h31.028c.75 0 1.447-.227 2.016-.612L27.567 26.185l-2.511 2.01c-.71.567-1.745.57-2.458.005l-2.549-2.021zm23.263-12.492 13.44 10.755a3.2 3.2 0 0 0 .095-.776v-20.81z"
  })));
};
export default SvgEmail;